/*Process Explanation

Initialization:

The script waits for the DOM to be fully loaded before executing.
It initializes various DOM elements and sets up event listeners.


Select2 Integration:

The script integrates Select2 for enhanced dropdown functionality.
It sets up event handlers for Select2 dropdowns to update hidden inputs and URL parameters.


Quote Management:

The script handles quote-related functionality, including updating the quote count and managing the quote drawer.
It uses AJAX to fetch and update quote information.


Product Details Fetching:

When a grade is selected, the script fetches product details via AJAX.
It then populates attribute dropdowns and enables/disables various UI elements based on the fetched data.
fetchProductDetails()

Variation Management:

As attributes are selected, the script fetches and updates product variations.
It handles the progressive revealing of attribute options based on previous selections.


URL Parameter Handling:

The script reads and sets URL parameters to maintain state across page reloads.
It initializes form fields based on URL parameters when the page loads.


UI Updates:

The script manages various UI elements, including showing/hiding spinners, enabling/disabling buttons, and updating product information displays.


Search Functionality:

It implements a toggle for the search form visibility.

if grade is set/updated,
    fetchProductDetails()
    showSpinner for first attribute
    populateAttributeSelect()
    setSelectValue() - if productID set, this just selects the first empty value
    updateVariationId()
    fetchVariations()
*/

document.addEventListener('DOMContentLoaded', function () {
	// Initialize variables and DOM elements
	let productId = '';
	const productIdInput = document.getElementById('product_id');
	const variationIdElem = document.getElementById('variation_id');
	const addToCartButton = document.getElementById('addToCartButton');
	const addToQuoteButton = document.getElementById('requestQuoteButton');
	const gradeInput = document.getElementById('grade_id');
	const gradeSelect = document.getElementById('grade');
	const attributeSelects = document.querySelectorAll('.attribute-dropdown');
	const attributeSelectIds = Array.from(attributeSelects).map((select) =>
		select.getAttribute('id')
	);
	let numOfSelects = attributeSelects.length - 1;
	let attributeNames = '';
	const lengthInput = document.getElementById('length');
	const unitsSelect = document.getElementById('units');
	const unitsInput = document.getElementById('units_id');
	const quoteCartBtn = document.querySelectorAll('.quote-cart a');
	const quoteCountElement = document.getElementById('quote-count');
	const quoteCountDisplay = document.querySelectorAll('.quote-item-count');
	const materialSpec = document.querySelector('#product-specs p');
	const weightUS = document.querySelector('#product-weight .us');
	const weightUK = document.querySelector('#product-weight .uk');
	const gradeName = document.getElementById('gradeName');
	const applications = document.querySelector(
		'#applications .collapse-content'
	);
	const equiv = document.getElementById('equiv');
	const chemistry = document.querySelector('#chemistry .collapse-content');
	const mechanical = document.querySelector('#mechanical .collapse-content');
	const tolerance = document.querySelector('#tolerance .collapse-content');
	const materialCert = document.getElementById('material_cert');
	const quoteDrawer = document.getElementById('quote-drawer');
	const productDetails = document.getElementById('productDetails');

	const spinner = createSpinner();
	function createSpinner() {
		const spinner = document.createElementNS(
			'http://www.w3.org/2000/svg',
			'svg'
		);
		spinner.setAttribute('class', 'animate-spin h-5 w-5 mr-3 spinner');
		spinner.setAttribute('viewBox', '0 0 24 24');
		spinner.innerHTML =
			'<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.963 7.963 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>';
		return spinner;
	}

	if (document.querySelector('[name="country"]')) {
		jQuery('[name="country"]').select2({
			minimumResultsForSearch: Infinity,
		});
	}

	// Quote count update function
	async function updateQuoteCount(setOpen) {
		try {
			const response = await fetch(quote_params.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams({
					action: 'get_quote_item_count',
					nonce: quote_params.nonce,
				}),
			});

			if (!response.ok) {
				throw new Error('Network response was not ok');
			}

			const data = await response.json();
			//console.log('quote number ', data);
			if (data.success) {
				const newQuoteCount = data.data.item_count;
				if (quoteCountDisplay) {
					if (newQuoteCount > 0) {
						quoteCountDisplay.forEach((el) => {
							el.textContent = newQuoteCount;
							if (!el.classList.contains('active')) {
								el.classList.add('active');
							}
						});
						quoteCartBtn.forEach((btn) => {
							if (!btn.classList.contains('filled')) {
								btn.classList.add('filled');
							}
						});
					} else {
						quoteCountDisplay.forEach((el) => {
							el.textContent = '';
							el.classList.remove('active');
						});
						quoteCartBtn.forEach((btn) => {
							if (btn.classList.contains('filled')) {
								btn.classList.remove('filled');
							}
						});
					}

					const quoteItems = data.data.quote_cart;
					displayQuoteDrawer(newQuoteCount, quoteItems, setOpen);
				}
			} else {
				console.error(data.data.message);
			}
		} catch (error) {
			console.error('Failed to update quote count:', error);
		}
	}

	// Function to display quote drawer
	function displayQuoteDrawer(itemCount, quoteCart, shouldOpen) {
		let drawerContent = `<ul class="list-none pl-0">`;
		for (let key in quoteCart) {
			if (quoteCart.hasOwnProperty(key)) {
				let item = quoteCart[key];
				let width = '';
				let units2 = '';

				item.attr.forEach((attr) => {
					if (attr.label === 'width')
						width = attr.value.replace(/-/g, '.');
					if (attr.label === 'units2')
						units2 = getDisplayUnits(attr.value);
				});

				drawerContent += `
                    <li id="drawer-${item.key}" class="py-3">
                        <div class="card card-side rounded-none">
                            ${
								item.categories.categories[0].thumbnail_url
									? `<figure class="mt-1.5 min-w-[70px] min-h-[70px]"><img loading="lazy" class="w-[70px] h-[70px] rounded" src="${item.categories.categories[0].thumbnail_url}" alt="${item.categories.categories[0].sub_name}" /></figure>`
									: ''
							}
                            <div class="card-body py-0 pr-0">
                                <h4 class="my-0">${
									item.categories.categories[0].sub_name
								} ${item.categories.grade}</h4>
                                <div class="flex justify-between">
                                    <div class="text-sm lg:text-base">
                                        ${item.attr
											.filter(
												(attr) =>
													![
														'length',
														'material_cert',
														'width',
														'units2',
													].includes(attr.label)
											)
											.map((attr) => {
												return `${
													attr.label
												}: ${attr.value.replace(
													/-/g,
													'.'
												)}<br/>`;
											})
											.join('')}

											${item.length != 0 ? `Length: ${item.length}` : `Length: `} ${getDisplayUnits(
					item.units_id
				)}<br/>
											${
												units2 === 'Stock Length'
													? 'Width: Stock Width<br/>'
													: width
													? `Width: ${width} ${units2}<br/>`
													: ''
											}


                                        ${
											item.material_certification === 1
												? 'Material Certification<br/>'
												: ''
										}
                                    </div>
                                    <div class="text-right text-sm lg:text-base">
                                        Qty: ${item.quantity}<br/>
                                        <a href="${
											item.key
										}" class="remove remove-cart-item remove-quote-item hover:text-secondary" aria-label="Remove this item" data-cart_item_key="${
					item.key
				}">Remove</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                `;
			}
		}
		drawerContent += `</ul>`;
		drawerContent += `<div class="block mb-4"><a href="/request-a-quote" class="btn btn-ghost w-full">View My Quote</a></div>`;
		drawerContent += `<div class="block mb-12"><a href="/" class="btn group w-full">
			<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-secondary fill-secondary group-hover:fill-white" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9.8s8.8 24.8-.8 33.9L83.9 232H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H83.9l132.7 126.6c9.6 9.2 9.9 24.3.8 33.9s-24.3 9.9-33.9.8l-176-168z"/></svg>
			Add Additional Items
		</a></div>`;

		document.getElementById(
			'insert-quote-content'
		).innerHTML = drawerContent;

		document
			.querySelectorAll('.remove-quote-item')
			.forEach(function (button) {
				console.log('quote remover!');
				button.addEventListener('click', function (e) {
					console.log('remove clied');
					const currentItem = this.closest('li');
					if (currentItem) {
						currentItem.appendChild(spinner);
						currentItem.classList.add('hide-me');
					} else {
						const currentItem = this.closest('.quote-item-block');
						currentItem
							.querySelector('.col-end-5')
							.appendChild(spinner);
						currentItem.classList.add('hide-me');
					}
				});
			});

		if (shouldOpen) {
			quoteDrawer.classList.add('open');
			//console.log('cart-open');
			document.body.classList.add('overflow-hidden', 'cart-open');
		}

		document
			.querySelector('.quote-drawer-close')
			.addEventListener('click', function () {
				quoteDrawer.classList.remove('open');
				document.body.classList.remove('overflow-hidden', 'cart-open');
			});
	}

	// Initialize quote count on page load
	updateQuoteCount(false);

	// AJAX request interception for quote updates
	(function (open) {
		XMLHttpRequest.prototype.open = function (
			method,
			url,
			async,
			user,
			pass
		) {
			this.addEventListener(
				'readystatechange',
				function () {
					if (this.readyState === 4 && this.status === 200) {
						if (url.includes('admin-ajax.php')) {
							try {
								// Parse the response
								const response = JSON.parse(this.responseText);
								// Check for the action in the request payload
								const params = new URLSearchParams(
									this._requestBody || ''
								);
								if (
									params.get('action') ===
									'add_to_quote_single_vari'
								) {
									if (
										response.message ===
										'Item added to quote.'
									) {
										//console.log('Item successfully added to quote:',response);
										updateQuoteCount(true);
									}
								}
								if (
									params.get('action') ===
									'update_quote_items'
								) {
									updateQuoteCount(false);
								}
								if (
									params.get('action') === 'remove_quote_item'
								) {
									/*console.log(
										'brah, remove it from the quote drawer'
									);*/
									updateQuoteCount(false);
								}
							} catch (e) {
								console.error('Error parsing response:', e);
							}
						}
					}
				},
				false
			);
			open.call(this, method, url, async, user, pass);
		};
		// Override send to capture the request payload
		const send = XMLHttpRequest.prototype.send;
		XMLHttpRequest.prototype.send = function (body) {
			this._requestBody = body;
			//console.log('Payload:', body);
			send.call(this, body);
		};
	})(XMLHttpRequest.prototype.open);

	// Event listeners for quantity input and material certification
	const quantityInput = document.getElementById('quantity');
	if (quantityInput) {
		quantityInput.addEventListener('input', function () {
			if (this.value < 1) {
				this.value = 1;
			}
		});
	}

	function capitalizeFirstLetter(string) {
		return string.length === 0
			? string
			: string.charAt(0).toUpperCase() + string.slice(1);
	}

	// Function to show error message
	function showError(message) {
		alert(message);
	}

	// Functions to enable/disable buttons
	function disableAddToCartButton() {
		if (addToCartButton) {
			addToCartButton.classList.add('disabled');
			addToCartButton.disabled = true;
		}
	}

	function enableAddToCartButton() {
		if (addToCartButton) {
			addToCartButton.classList.remove('disabled');
			addToCartButton.disabled = false;
		}
	}

	function getDisplayUnits(unitsId) {
		const unitsMap = {
			'stock-length': 'Stock Length',
			feet: 'Feet',
			inches: 'Inches',
			meters: 'Meters',
			millimeters: 'Millimeters',
		};
		return unitsMap[unitsId] || unitsId;
	}

	// Event listener for quote cart link

	document.querySelectorAll('.quote-cart a').forEach((el) => {
		el.addEventListener('click', function (event) {
			event.preventDefault();
			quoteDrawer.classList.toggle('open');
			//console.log('this one');
			if (!document.body.classList.contains('overflow-hidden')) {
				//console.log('blur body');
				document.body.classList.add('overflow-hidden', 'cart-open');
			}
		});
	});

	/* Duplicate quote */
	jQuery(document).on('click', '.duplicate-quote-btn', function (e) {
		e.preventDefault();
		const button = jQuery(this);
		const quoteID = jQuery(this).data('quote-id');
		const nonce = jQuery(this).data('nonce');
		const afquoteNonce = window.afquoteAjax?.nonce;

		button.prop('disabled', true).text('Duplicating...');

		jQuery.ajax({
			url: '/wp-admin/admin-ajax.php',
			method: 'GET',
			data: {
				action: 'duplicate_quote_to_cart',
				quote_id: quoteID,
				_wpnonce: nonce,
				afquote_nonce: afquoteNonce, // needed for custom_add_to_quote_single_vari
			},
			success(responseText) {
				let response;

				try {
					response =
						typeof responseText === 'string'
							? JSON.parse(responseText)
							: responseText;
				} catch (e) {
					console.error(
						'Invalid JSON response from server:',
						responseText
					);
					//alert('Unexpected server response. Please try again.');
					return;
				}

				if (response && response.success) {
					updateQuoteCount(true);
					button.hide();
				}
			},
			error(xhr, status, error) {
				console.error('AJAX error:', error, xhr.responseText);
			},
		});
	});

	// Search form functionality
	const searchContainer = document.getElementById('search-container');
	const searchToggle = document.getElementById('search-toggle');
	const searchForm = document.getElementById('search-form');
	const searchInput = document.getElementById('search-input');

	function toggleSearch() {
		const isOpen = searchForm.classList.contains('visible');
		searchForm.classList.toggle('visible');
		searchToggle.setAttribute('aria-expanded', !isOpen);
		searchToggle.classList.toggle('swap-active');

		if (!isOpen) {
			setTimeout(() => {
				searchInput.focus();
			}, 300); // Wait for the animation to complete
		}
	}

	searchToggle.addEventListener('click', toggleSearch);
	searchToggle.addEventListener('keydown', function (event) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			toggleSearch();
		}
	});

	// Close search when clicking outside
	document.addEventListener('mousedown', function (event) {
		if (
			!searchContainer.contains(event.target) &&
			searchForm.classList.contains('visible')
		) {
			toggleSearch();
		}
	});

	// Close search when pressing Escape key
	document.addEventListener('keydown', function (event) {
		if (
			event.key === 'Escape' &&
			searchForm.classList.contains('visible')
		) {
			toggleSearch();
			searchToggle.focus();
		}
		if (event.key === 'Enter' && quoteDrawer.classList.contains('open')) {
			quoteDrawer.classList.remove('open');
		}
	});
	// Handle tab key to manage focus
	searchForm.addEventListener('keydown', function (event) {
		if (event.key === 'Tab' && !event.shiftKey) {
			if (
				document.activeElement ===
				searchForm.querySelector('.search-submit')
			) {
				event.preventDefault();
				searchToggle.focus();
			}
		}
	});

	searchToggle.addEventListener('keydown', function (event) {
		if (event.key === 'Tab' && event.shiftKey) {
			if (searchForm.classList.contains('visible')) {
				event.preventDefault();
				searchForm.querySelector('.search-submit').focus();
			}
		}
	});

	// if account page, get current tab on page load
	const umAccountMain = document.querySelector('.um-account-main');
	if (umAccountMain) {
		const umAccountTabs = document.querySelectorAll('.um-account-tab');
		const currentTab = document
			.querySelector('.um-account-main')
			.getAttribute('data-current_tab');
		umAccountTabs.forEach((tab) => {
			if (tab.getAttribute('data-tab') == currentTab) {
				tab.style.display = 'block';
			}
		});
	}

	const menuButton = document.getElementById('hamburger');
	const mobileNav = document.getElementById('menu-mobile');
	const mobileToggle = document.getElementById('menu-toggle');

	menuButton.addEventListener('click', toggleMenu);

	function toggleMenu() {
		mobileToggle.checked = !mobileToggle.checked;
		menuButton.setAttribute('aria-expanded', mobileToggle.checked);
		mobileNav.classList.toggle('hidden');
		mobileNav.classList.toggle('grid');
		document.body.classList.toggle('overflow-hidden');
	}

	const subButton = document.getElementById('sub-btn');
	const subMenuNav = document.getElementById('submenu');
	const submenuToggle = document.getElementById('submenu-toggle');

	subButton.addEventListener('click', toggleSubMenu);

	function toggleSubMenu() {
		submenuToggle.checked = !submenuToggle.checked;
		subButton.setAttribute('aria-expanded', submenuToggle.checked);
		subMenuNav.classList.toggle('hidden');
	}

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !mobileNav.classList.contains('hidden')) {
			toggleMenu();
			menuButton.focus();
		}
	});
	const megaItems = document.querySelectorAll('.dropdown-content.menu a');
	const megaImages = document.querySelectorAll(
		'#menu-quote-menu #menu-img span'
	);
	if (megaItems) {
		megaItems.forEach((item) => {
			item.addEventListener('mouseenter', function () {
				let parent = this.closest('[class^="get-"]');
				if (parent) {
					let className = Array.from(parent.classList).find((cls) =>
						cls.startsWith('get-')
					);
					if (className) {
						let material = className.replace('get-', '');
						megaImages.forEach((img) =>
							img.classList.add('hidden')
						);
						let imageToShow = document.querySelector(
							`#menu-img .${material}`
						);
						if (imageToShow) {
							imageToShow.classList.remove('hidden');
							imageToShow.classList.add('z-10');
						}
					}
				}
			});
		});
	}

	const menuImgContainer = document.querySelector('#menu-img');
	menuImgContainer.addEventListener('mouseleave', function () {
		megaImages.forEach((img) => img.classList.add('hidden'));
		// Assuming 'carbon' is the default image
		let defaultImage = document.querySelector('#menu-img .carbon');
		if (defaultImage) {
			defaultImage.classList.remove('hidden');
		}
	});

	/* stop select zoom on iOS */
	document.addEventListener(
		'touchstart',
		(event) => {
			if (event.target.tagName === 'SELECT') {
				event.preventDefault();
			}
		},
		{ passive: false }
	);

	// if reusing duplicated file field
	/*const submitForm = document.querySelector('form#submit-request');
	if (submitForm) {
		const reuseCheckbox = document.getElementById('reuse_previous_file');
		const fileInput = document.getElementById('afrfq_field_132358');
		const hiddenReuseField = document.createElement('input');
		hiddenReuseField.type = 'hidden';
		hiddenReuseField.name = 'afrfq_field_132358_reuse';
		hiddenReuseField.value = '';

		submitForm.appendChild(hiddenReuseField);
		if (reuseCheckbox && document.cookie.includes('quote_file')) {
			const match = document.cookie.match(/quote_file=([^;]+)/);
			if (match && match[1]) {
				reuseCheckbox.addEventListener('change', function () {
					hiddenReuseField.value = this.checked
						? decodeURIComponent(match[1])
						: '';
				});
			}
		}
		// toggle file being disabled
		if (reuseCheckbox && fileInput) {
			reuseCheckbox.addEventListener('change', function () {
				fileInput.disabled = this.checked;
			});
		}
	}
	*/
	/* set order_for value for customer user registration form */
	function getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null
			? ''
			: decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	// Get the 'company' parameter from the URL
	var companyValue = getUrlParameter('company');

	// Find the 'order_for' input field
	var orderForField = document.querySelector('input[data-key="order_for"]');

	// If the field exists and we have a company value, set it
	if (orderForField && companyValue) {
		orderForField.value = companyValue;
	}

	const collapseContainers = document.querySelectorAll(
		'[data-collapse-container]'
	);

	collapseContainers.forEach((container) => {
		const label = container.querySelector('.collapse-title');
		const checkbox = container.querySelector('input[type="checkbox"]');
		const content = container.querySelector('.collapse-content');

		function updateState() {
			const isExpanded = checkbox.checked;
			label.setAttribute('data-expanded', isExpanded);
			if (isExpanded) {
				content.removeAttribute('hidden');
			} else {
				content.setAttribute('hidden', '');
			}
		}

		function toggleCollapse() {
			checkbox.checked = !checkbox.checked;
			updateState();
		}

		// Handle keyboard events on the label
		checkbox.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				toggleCollapse();
			}
		});

		// Update state when checkbox changes (for any other interactions)
		checkbox.addEventListener('change', updateState);

		// Initial setup
		updateState();
	});
	// disable form submit when updating quantity for request-a-quote

	var form = document.getElementById('submit-request');
	var numberInputs = document.querySelectorAll('.number-input');

	// Prevent form submission on enter key press
	if (form) {
		form.addEventListener('keypress', function (e) {
			if (e.keyCode === 13 || e.which === 13) {
				e.preventDefault();
				return false;
			}
		});
	}
	numberInputs.forEach(function (container) {
		var input = container.querySelector('input[type="number"]');
		var incrementBtn = container.querySelector('.increment');
		var decrementBtn = container.querySelector('.decrement');

		if (input && incrementBtn && decrementBtn) {
			// Remove existing event listeners if any
			incrementBtn.removeEventListener('click', incrementHandler);
			decrementBtn.removeEventListener('click', decrementHandler);
			input.removeEventListener('change', inputChangeHandler);

			// Add new event listeners
			incrementBtn.addEventListener('click', incrementHandler);
			decrementBtn.addEventListener('click', decrementHandler);
			input.addEventListener('change', inputChangeHandler);
		}
	});

	function incrementHandler(e) {
		console.log('plus');
		e.preventDefault();
		var input = this.closest('.number-input').querySelector(
			'input[type="number"]'
		);
		input.stepUp();
		triggerChangeEvent(input);
	}

	function decrementHandler(e) {
		e.preventDefault();
		var input = this.closest('.number-input').querySelector(
			'input[type="number"]'
		);
		input.stepDown();
		triggerChangeEvent(input);
	}

	function inputChangeHandler(e) {
		e.preventDefault();
		// Add your custom logic here for handling quantity changes
		//console.log('Quantity changed to: ' + this.value);
	}

	function triggerChangeEvent(input) {
		input.dispatchEvent(new Event('change', { bubbles: true }));
	}
	// toggle password fields
	const passwords = document.querySelectorAll('.um-toggle-password');
	passwords.forEach(function (password) {
		password.addEventListener('click', function (e) {
			password.classList.toggle('show');
			const container = this.closest('.um-field');
			const input = container.querySelector('input');
			if (input.type === 'password') {
				input.type = 'text';
			} else {
				input.type = 'password';
			}
		});
	});

	// on product page, only keep All visible on scroll
	/*const carouselContainer = document.getElementById('carousel-container');
	if (carouselContainer) {
		const nav = document.getElementById('product-category-nav');

		const keepItem = document.getElementById('keep-me');
		const otherItems = nav.querySelectorAll('.carousel-item:not(#keep-me)');

		let carouselOriginalTop =
			carouselContainer.getBoundingClientRect().top + window.pageYOffset;
		let isCompact = false;
		let rafId = null;

		function editPlacement() {
			const shouldBeCompact = window.pageYOffset > carouselOriginalTop;

			if (shouldBeCompact !== isCompact) {
				isCompact = shouldBeCompact;

				if (isCompact) {
					carouselContainer.classList.add('justify-start');
					keepItem.classList.add('w-full');
					otherItems.forEach((item) => item.classList.add('hidden'));
				} else {
					carouselContainer.classList.remove('justify-start');
					keepItem.classList.remove('w-full');
					otherItems.forEach((item) =>
						item.classList.remove('hidden')
					);
				}
			}

			rafId = null;
		}

		function onScroll() {
			if (!rafId) {
				rafId = requestAnimationFrame(editPlacement);
			}
		}

		function onResize() {
			carouselOriginalTop =
				carouselContainer.getBoundingClientRect().top +
				window.pageYOffset;
			editPlacement();
		}

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onResize);

		// Initial check
		editPlacement();
	}*/

	// conversion calculators
	document.querySelectorAll('#first-calc input').forEach((input) => {
		input.addEventListener('keyup', function () {
			const inches = this.classList.contains('inches');
			const feet = this.classList.contains('feet');
			const yards = this.classList.contains('yards');
			const millimeters = this.classList.contains('millimeters');
			const meters = this.classList.contains('meters');
			const numberCalc = this.value;

			//console.log('keyup ', this.id);
			document
				.querySelector('[data-name="' + this.id + '"]')
				.classList.remove('hidden');

			if (numberCalc === '') return;

			const updateValues = () => {
				if (inches) {
					document.querySelector('#first-calc #inches').value = (
						numberCalc * 1
					).toFixed(3);
					document.querySelector('#first-calc #feet').value = (
						numberCalc * 0.08333
					).toFixed(3);
					document.querySelector('#first-calc #yards').value = (
						numberCalc * 0.02778
					).toFixed(3);
					document.querySelector('#first-calc #millimeters').value = (
						numberCalc * 25.4
					).toFixed(3);
					document.querySelector('#first-calc #meters').value = (
						numberCalc * 0.0254
					).toFixed(3);
				} else if (feet) {
					document.querySelector('#first-calc #inches').value = (
						numberCalc * 12
					).toFixed(3);
					document.querySelector('#first-calc #feet').value = (
						numberCalc * 1
					).toFixed(3);
					document.querySelector('#first-calc #yards').value = (
						numberCalc * 0.333333
					).toFixed(3);
					document.querySelector('#first-calc #millimeters').value = (
						numberCalc * 304.8
					).toFixed(3);
					document.querySelector('#first-calc #meters').value = (
						numberCalc * 0.3048
					).toFixed(3);
				} else if (yards) {
					document.querySelector('#first-calc #inches').value = (
						numberCalc * 36
					).toFixed(3);
					document.querySelector('#first-calc #feet').value = (
						numberCalc * 3
					).toFixed(3);
					document.querySelector('#first-calc #yards').value = (
						numberCalc * 1
					).toFixed(3);
					document.querySelector('#first-calc #millimeters').value = (
						numberCalc * 914.4
					).toFixed(3);
					document.querySelector('#first-calc #meters').value = (
						numberCalc * 0.914
					).toFixed(3);
				} else if (millimeters) {
					document.querySelector('#first-calc #inches').value = (
						numberCalc * 0.03937
					).toFixed(3);
					document.querySelector('#first-calc #feet').value = (
						numberCalc * 0.003280833
					).toFixed(3);
					document.querySelector('#first-calc #yards').value = (
						numberCalc * 0.001093611
					).toFixed(3);
					document.querySelector('#first-calc #millimeters').value = (
						numberCalc * 1
					).toFixed(3);
					document.querySelector('#first-calc #meters').value = (
						numberCalc * 0.001
					).toFixed(3);
				} else if (meters) {
					document.querySelector('#first-calc #inches').value = (
						numberCalc * 39.37008
					).toFixed(3);
					document.querySelector('#first-calc #feet').value = (
						numberCalc * 3.28084
					).toFixed(3);
					document.querySelector('#first-calc #yards').value = (
						numberCalc * 1.0936133
					).toFixed(3);
					document.querySelector('#first-calc #millimeters').value = (
						numberCalc * 1000
					).toFixed(3);
					document.querySelector('#first-calc #meters').value = (
						numberCalc * 1
					).toFixed(3);
				}
				document
					.querySelector('[data-name="' + this.id + '"]')
					.classList.add('hidden');
			};

			setTimeout(updateValues, 3000);
		});
	});

	document.querySelectorAll('#two-calc input').forEach((input) => {
		input.addEventListener('keyup', function () {
			document
				.querySelector('[data-name="' + this.id + '"]')
				.classList.remove('hidden');
			const pounds = this.classList.contains('pounds');
			const kilograms = this.classList.contains('kilograms');
			const numberCalc = this.value;

			if (numberCalc === '') return;

			const updateValues = () => {
				if (pounds) {
					document.querySelector('#two-calc #pounds').value = (
						numberCalc * 1
					).toFixed(3);
					document.querySelector('#two-calc #kilograms').value = (
						numberCalc * 0.4536
					).toFixed(3);
				} else if (kilograms) {
					document.querySelector('#two-calc #pounds').value = (
						numberCalc * 2.2046
					).toFixed(3);
					document.querySelector('#two-calc #kilograms').value = (
						numberCalc * 1
					).toFixed(3);
				}
				document
					.querySelector('[data-name="' + this.id + '"]')
					.classList.add('hidden');
			};

			setTimeout(updateValues, 3000);
		});
	});

	document.querySelectorAll('#three-calc input').forEach((input) => {
		input.addEventListener('keyup', function () {
			document
				.querySelector('[data-name="' + this.id + '"]')
				.classList.remove('hidden');
			const fahrenheit = this.classList.contains('fahrenheit');
			const celsius = this.classList.contains('celsius');
			const numberCalc = this.value;

			if (numberCalc === '') return;

			const updateValues = () => {
				if (fahrenheit) {
					document.querySelector('#three-calc #fahrenheit').value = (
						numberCalc * 1
					).toFixed(2);
					document.querySelector('#three-calc #celsius').value = (
						(numberCalc - 32) /
						1.8
					).toFixed(2);
				} else if (celsius) {
					document.querySelector('#three-calc #fahrenheit').value = (
						numberCalc * 1.8 +
						32.0
					).toFixed(2);
					document.querySelector('#three-calc #celsius').value = (
						numberCalc * 1
					).toFixed(2);
				}
				document
					.querySelector('[data-name="' + this.id + '"]')
					.classList.add('hidden');
			};

			setTimeout(updateValues, 3000);
		});
	});

	if (document.querySelector('#resetcalc')) {
		document
			.querySelector('#resetcalc')
			.addEventListener('click', function () {
				document
					.querySelectorAll(
						'#first-calc input, #two-calc input, #three-calc input'
					)
					.forEach((input) => {
						input.value = '';
					});
			});
	}

	/* how to video */
	let player;

	function initializeVimeoPlayer(iframe) {
		if (!window.Vimeo) {
			const script = document.createElement('script');
			script.src = 'https://player.vimeo.com/api/player.js';
			script.onload = () => {
				// Create player once API is loaded
				player = new Vimeo.Player(iframe);
			};
			document.body.appendChild(script);
		} else {
			// Create player if API is already loaded
			player = new Vimeo.Player(iframe);
		}
	}
	const notification = document.getElementById('notification-how');
	const overlay = document.getElementById('how-overlay');

	const toggleBtn = document.getElementById('toggle-btn');
	const closeBtnM = document.getElementById('close-btnM');
	const videoContainer = document.querySelector(
		'#notification-how #video-container'
	);
	const thumbnailContainer = document.getElementById('thumbnail-container');

	// Select the iframe for the Vimeo player
	let isVideoLoaded = false;

	// Show notification after 3 seconds
	if (!getCookie('notificationSeen')) {
		setTimeout(() => {
			notification.classList.remove('hidden');
			/*notification.classList.remove('translate-y-full');*/
			notification.style.transform = 'translateX(0px)';
		}, 3000);
		setCookie('notificationSeen', 'true', 7);
	} else {
		toggleBtn.classList.remove('hidden');
	}

	// Toggle visibility of the notification
	toggleBtn.addEventListener('click', () => {
		notification.classList.contains('hidden')
			? showNotification()
			: closeNotification();
	});

	// Close button functionality
	closeBtnM.addEventListener('click', () => {
		closeNotification();
	});
	// Close notification on overlay click
	overlay.addEventListener('click', () => {
		closeNotification();
	});

	// Function to show the notification
	function showNotification() {
		notification.classList.remove('hidden');
		notification.style.transform = 'translateX(0px)';
		overlay.classList.remove('hidden');
		videoContainer.classList.remove('hidden');
		thumbnailContainer.classList.add('hidden');
		let iframe;
		if (!isVideoLoaded) {
			const iframe = document.createElement('iframe');
			iframe.setAttribute(
				'src',
				'https://player.vimeo.com/video/1020652234?badge=0&byline=0&title=0&portrait=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
			);
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute(
				'allow',
				'autoplay; fullscreen; picture-in-picture; clipboard-write'
			);
			iframe.setAttribute('title', 'MetricMetal.com New Site Tutorial');
			iframe.style.position = 'absolute';
			iframe.style.top = '0';
			iframe.style.left = '0';
			iframe.style.width = '100%';
			iframe.style.height = '100%';
			// Append the iframe to the video container
			videoContainer.appendChild(iframe);
			initializeVimeoPlayer(iframe);
			isVideoLoaded = true;
		}
	}

	function closeNotification() {
		notification.classList.add('hidden');
		toggleBtn.classList.remove('hidden');
		overlay.classList.add('hidden');
		videoContainer.classList.add('hidden'); // Hide video when closed
		thumbnailContainer.classList.remove('hidden');
		if (player) {
			player.pause().catch((error) => {
				console.log('error pausing video');
			});
		}
		//player.pause();
	}
	// Enlarge the notification
	notification.addEventListener('click', () => {
		if (!notification.classList.contains('hidden')) {
			notification.classList.toggle('enlarged');
			if (!isVideoLoaded) {
				const iframe = document.createElement('iframe');
				iframe.setAttribute(
					'src',
					'https://player.vimeo.com/video/1020652234?badge=0&byline=0&title=0&portrait=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'
				);
				iframe.setAttribute('frameborder', '0');
				iframe.setAttribute(
					'allow',
					'autoplay; fullscreen; picture-in-picture; clipboard-write'
				);
				iframe.setAttribute(
					'title',
					'MetricMetal.com New Site Tutorial'
				);
				iframe.style.position = 'absolute';
				iframe.style.top = '0';
				iframe.style.left = '0';
				iframe.style.width = '100%';
				iframe.style.height = '100%';
				// Append the iframe to the video container
				videoContainer.appendChild(iframe);
				initializeVimeoPlayer(iframe);
				isVideoLoaded = true;
			}
			overlay.classList.remove('hidden');
			videoContainer.classList.remove('hidden');
			thumbnailContainer.classList.add('hidden');
		} else {
			overlay.classList.add('hidden');
			videoContainer.classList.add('hidden');
			thumbnailContainer.classList.remove('hidden');

			if (player) {
				player.pause().catch((error) => {
					console.log('error pausing vid', error);
				});
			}
		}
	});
});
// set/get cookies for checkboxes
function setCookie(name, value, days) {
	//console.log('set cookide: ', name);
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}
function getCookie(name) {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
function handleCheckbox(checkbox) {
	if (checkbox.checked) {
		setCookie(checkbox.name, 'true', 30);
	} else {
		setCookie(checkbox.name, '', -1);
	}
}

window.onload = function () {
	var checkboxes = document.getElementsByClassName('checkbox');
	for (var i = 0; i < checkboxes.length; i++) {
		var checkbox = checkboxes[i];
		var cookieValue = getCookie(checkbox.name);
		if (cookieValue === 'true') {
			checkbox.checked = true;
		}
		checkbox.addEventListener('change', function () {
			handleCheckbox(this);
		});
	}
};
